import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../imageService';

const IntroScreen = ({ onStart, onSkip }) => {
  return (
    <div
      className={styles.screen}
      style={{
        backgroundImage: `url(${getImageFromS3('/images/tarot/bg.png')})`
      }}
    >
      <div className={styles.cardsArea}>
        <div className={styles.cardCluster}>
          <img
            className={`${styles.card} ${styles.cardLeft}`}
            src={getImageFromS3('/images/tarot/base-card.png')}
            alt="base-card-1"
          />
          <img
            className={`${styles.card} ${styles.cardRight}`}
            src={getImageFromS3('/images/tarot/base-card.png')}
            alt="base-card-2"
          />
          <img
            className={`${styles.card} ${styles.cardCenter}`}
            src={getImageFromS3('/images/tarot/welcome-card.png')}
            alt="welcome-card"
          />
        </div>
      </div>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primary}
          style={{
            backgroundImage: `url(${getImageFromS3(
              '/images/tarot/button-bg.png'
            )})`
          }}
          onClick={onStart}
        >
          Почати
        </button>
        <button type="button" className={styles.skip} onClick={onSkip}>
          Пропустити
        </button>
      </div>
    </div>
  );
};

export default IntroScreen;
